<div class="main-content">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-md-8 user-col ">
        <div class="card card-profile">
          <div class="card-avatar">
            <a href="javascript:void(0)">
              <img class="img" src="{{s3url}}/profiles/{{profile?.faculty_id}}.jpg" onError="this.src='./assets/img/faces/marc.png';" />
            </a>
          </div>
          <div class="card-body">
            <h4 class="card-title">{{profile?.faculty_name}}</h4>

            <div class="table-responsive text-left">
              <table class="table">
                <tbody>
                  <tr>
                    <td> Member Id</td>
                    <td> {{profile?.staff_code}}</td>
                  </tr>
                  <tr>
                    <td>Name</td>
                    <td> {{profile?.faculty_name}}</td>
                  </tr>

                  <tr>
                    <td>Permanent Address</td>
                    <td>{{profile?.faculty_address}}</td>
                  </tr>
                  <!-- <tr>
                    <td>Joined Date</td>
                    <td>{{profile?.faculty_join_date|date:'dd-MM-yyyy'}}</td>
                  </tr> -->
                  <!-- <tr>
                    <td>Qualification</td>
                    <td>{{profile?.qualification}}</td>
                  </tr> -->
                  <!-- <tr>
                    <td>Designation</td>
                    <td>{{profile?.designation}}</td>
                  </tr> -->
                  <tr>
                    <td>Email</td>
                    <td><a href="mailto:{{profile?.faculty_email}}">{{profile?.faculty_email}}</a></td>
                  </tr>
                  <tr>
                    <td>Mobile Number</td>
                    <td>{{profile?.faculty_mobile}}</td>
                  </tr>
                  <tr>
                    <td>Nationality</td>
                    <td>{{profile?.country_name}}</td>
                  </tr>

                  <tr>
                    <td>User Name</td>
                    <td>{{profile?.username}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <mat-list>
              <mat-divider></mat-divider>
              <div mat-subheader>Password Settings</div>
              <mat-list-item>
                <div matLine>
                  <button mat-button color="primary" (click)="show_change_pas =!show_change_pas">
                    <mat-icon>{{show_change_pas?'lock_open':'lock'}}</mat-icon>Change password
                  </button>
                </div>
              </mat-list-item>
              <form [formGroup]="password_change_form" (ngSubmit)="onPasswordChange()" *ngIf="show_change_pas">
                <mat-list-item>
                  <div matLine class="col-md-6">
                    <mat-form-field>
                      <input type="password" matInput placeholder="Current Password" formControlName="current_password">
                    </mat-form-field>
                  </div>
                </mat-list-item>
                <mat-list-item>
                  <div matLine class="col-md-6">

                    <mat-form-field>
                      <input type="password" matInput placeholder="New Password" formControlName="password">
                    </mat-form-field>
                  </div>
                </mat-list-item>
                <mat-list-item>
                  <div matLine class="col-md-6">

                    <mat-form-field>
                      <input type="password" matInput placeholder="Confirm Password" formControlName="password_confirmation">
                    </mat-form-field>
                  </div>
                </mat-list-item>
                <button mat-flat-button color="primary" type="submit">
                  Change
                </button>
              </form>
            </mat-list>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--  -->
<!--  -->